import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import * as Constants from '../constants';

class CampaignsPublishBtn extends Component {
  static propTypes = {
    campaign: PropTypes.object.isRequired,
    handlePublish: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showWarningModal: false,
      disabledPublish: false,
      disabledWarning: false
    };
  }

  closeModal() {
    this.setState({ showModal: false, disabledPublish: false });
  }

  openModal() {
    this.setState({ showModal: true, disabledWarning: false });
  }

  closeWarningModal() {
    this.setState({ showWarningModal: false, disabledPublish: false });
  }

  openWarningModal() {
    this.setState({ showWarningModal: true, disabledWarning: false });
  }

  onPublishWarning() {
    const { campaign } = this.props;
    if ((campaign.type != "StarterCampaign") && (
        ( String(campaign.filter_sender_ids) == "Any Agent"     && String(campaign.filter_source_names) == "Any Source") ||
        ( String(campaign.filter_sender_ids) == "None Selected" && String(campaign.filter_source_names) == "Any Source") ||
        ( String(campaign.filter_sender_ids) == "Any Agent"     && String(campaign.filter_source_names) == "None Selected")
      )
    )
    {
      this.openWarningModal();
    } else {
      this.setState({ disabledPublish: true });
      this.onPublishConfirm();
    }
  }

  onPublishConfirm() {
    const { campaign } = this.props;
    if (
      campaign.subscription_count == 0 ||
      campaign.type == "StarterCampaign"
    ) {
      this.setState({ disabledWarning: true });
      this.onPublishClick();
    } else {
      this.setState({ disabledWarning: true });
      this.onPublishClick();
    }
  }

  onPublishClick() {
    this.setState({ disabledWarning: true });
    this.props.handlePublish(this.props.campaign.id, false);
    this.closeModal();
  }

  render() {
    return (
      <div>
        <button
          className="btn btn-primary pull-right publish_btn"
          onClick={this.onPublishWarning.bind(this)}
          disabled={this.state.disabledPublish}
        >
          Publish
        </button>
        <Modal
          show={this.state.showWarningModal}
          onHide={this.closeWarningModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={true}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">
              Do you want to subscribe all new leads?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            The current filter settings will subscribe all new leads to this
            campaign. Click &#39;Publish&#39; to continue with these settings or
            &#39;Cancel&#39; to make changes to your filter.
            <div className="row m-t-20 m-b-20 text-center">
              <button
                className="btn btn-default"
                onClick={this.closeWarningModal.bind(this)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary m-l-10"
                onClick={this.onPublishConfirm.bind(this)}
                disabled={this.state.disabledWarning}
              >
                Publish
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default CampaignsPublishBtn;
